import React from 'react';
import SignupForm from '../components/Form/SignupForm';
import { DefaultSeo } from 'next-seo';
import SEOHead from '../components/SEOHead';
import * as m from 'framer-motion/m';

const Signup = () => {
  return (
    <>
      <SEOHead title='Sign Up | GadgetFever' description='Create your GadgetFever account.' noIndex />
      <div className='min-h-screen bg-[#e8e8e8] dark:bg-black'>
        <m.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className='min-h-screen flex flex-col items-center px-4 pt-2 sm:pt-3 pb-8'
        >
          <SignupForm />
        </m.div>
      </div>
    </>
  );
};

export default Signup;
